module.exports = __webpack_public_path__ + "img/IT0000125236845.52b5a139.png";